<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card v-if="!param.nikakun">
          <v-card-text>
            <v-alert
              border="left"
              text
              type="error">
              Data tidak ditemukan!
              <v-btn
                class="ml-2 right"
                :to="backbtn"
                color="error"
                outlined
                x-small>
                Back
              </v-btn>
            </v-alert>
          </v-card-text>
        </v-card>
        <v-card v-if="param.nikakun">
          <v-card-title>
            <v-icon
              medium
              left>
              email
            </v-icon>
            <span class="title"><b>{{ param.nikakun }}</b></span>
            <v-spacer></v-spacer>
            <v-btn
              :to="backbtn"
              color="error"
              icon
              x-small>
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <alertsp :alertdata="alertgetdata"></alertsp>
              <div class="text-center" v-if="loading.getdata">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </div>
              <v-row justify="center" v-if="detaildata">
                <v-col cols="12" md="8" class="px-md-10 border-solid-thin text-justify" v-if="!loading.getdata">
                  <v-row justify="center" align="center">
                    <v-col cols="12" md="2" class="text-center">
                      <img class="mr-3" :src="require('../../assets/' + prefix + '/logo.png')" height="100"/>
                    </v-col>
                    <v-col cols="12" md="10" class="text-center">
                      <div class="headline text-uppercase">PEMERINTAH KABUPATEN {{ staticdata.kabupaten }}</div>
                      <div class="headline text-uppercase">KECAMATAN {{ staticdata.kecamatan }}</div>
                      <div class="headline text-uppercase">DESA {{ staticdata.desa }}</div>
                      <p>{{ staticdata.alamat }} | No.Telp: {{ staticdata.phone }}</p>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <div class="text-center text-underline title">KARTU KELUARGA</div>
                      <div class="text-center">Nomor: {{ detaildata.no_kk }}</div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-list-item dense>
                        <v-list-item-content>
                          <v-list-item-title>Nama:</v-list-item-title>
                          <v-list-item-subtitle class="space-break"><span>{{ detaildata.nama }}</span></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item dense>
                        <v-list-item-content>
                          <v-list-item-title>Kelurahan:</v-list-item-title>
                          <v-list-item-subtitle class="space-break"><span>{{ detaildata.kel_ktp }}</span></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-list-item dense>
                        <v-list-item-content>
                          <v-list-item-title>Kecamatan:</v-list-item-title>
                          <v-list-item-subtitle class="space-break"><span>{{ detaildata.kec_ktp }}</span></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item dense>
                        <v-list-item-content>
                          <v-list-item-title>Kabupaten:</v-list-item-title>
                          <v-list-item-subtitle class="space-break"><span>{{ detaildata.kab_ktp }}</span></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-list-item dense>
                        <v-list-item-content>
                          <v-list-item-title>Banjar:</v-list-item-title>
                          <v-list-item-subtitle class="space-break"><span>{{ detaildata.banjar_ktp }}</span></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item dense>
                        <v-list-item-content>
                          <v-list-item-title>Kode Pos:</v-list-item-title>
                          <v-list-item-subtitle class="space-break"><span>{{ detaildata.pos_ktp }}</span></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12">
                      <v-list-item dense>
                        <v-list-item-content>
                          <v-list-item-title>Alamat:</v-list-item-title>
                          <v-list-item-subtitle class="space-break"><span>{{ detaildata.alamat }}</span></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <v-data-table
                        class="table-nowrap"
                        :headers="headers"
                        :items="datakk"
                        :search="filter.search">
                        <template v-slot:[`item.action`]="{ item }">
                          <v-btn
                            :to="{ name: 'PendudukdetailAdmin', query: { type: item.role, nik: item.nik } }"
                            x-small
                            icon
                            exact>
                            <v-icon>search</v-icon>
                          </v-btn>
                          <v-btn
                            :to="{ name: 'SuratAdmin', query: { tab: 'tab-addnew', nik: item.nik } }"
                            x-small
                            icon
                            exact>
                            <v-icon>mail</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4" class="pl-md-10 pt-md-0" v-if="!loading.getdata">
                  <v-form
                    ref="formupdatdata"
                    @submit.prevent="submitUpdate"
                    v-model="formadd.valid"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.nama"
                          label="Nama"
                          name="namaakun">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.nik"
                          label="NIK"
                          name="nikakun">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-select
                          :items="listkelamin"
                          name="kelamin"
                          v-model="detaildata.kelamin"
                          label="Jenis kelamin">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="7">
                        <v-select
                          :items="listagama"
                          v-model="detaildata.agama"
                          name="agama"
                          label="Agama">
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="detaildata.tempat_lahir"
                          label="Tempat lahir *"
                          :rules="[rules.required]"
                          name="tempatlahir"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-menu
                          v-model="datepick.tgllahir"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="detaildata.tanggal_lahir"
                              label="Tanggal lahir *"
                              readonly
                              :rules="[rules.required]"
                              v-on="on">
                            </v-text-field>
                          </template>
                          <v-date-picker
                            ref="birthday"
                            :max="datepick.date"
                            name="tgllahir"
                            v-model="detaildata.tanggal_lahir"
                            @input="datepick.tgllahir = false">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          :items="listpendidikan"
                          name="pendidikan"
                          v-model="detaildata.pendidikan"
                          label="Pendidikan">
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="detaildata.pekerjaan"
                          :items="listpekerjaan"
                          item-value="nama_kerja"
                          item-text="nama_kerja"
                          label="Pekerjaan">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="detaildata.email"
                          label="E-mail"
                          name="email"
                          type="email"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="detaildata.phone"
                          label="Telephone"
                          name="telephone"
                          :counter="12"
                          :rules="[rules.phone]"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="detaildata.alamat"
                          auto-grow
                          label="Alamat*"
                          :rules="[rules.required]"
                          rows="1">
                        </v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.updatdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <alertsp :alertdata="alertdata"></alertsp>
                        <v-btn
                          v-if="!loading.updatdata"
                          large
                          block
                          :disabled="!formadd.valid"
                          color="success"
                          class="mr-4 mt-5"
                          type="submit">
                          Update
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getDateTodayId } from '../../utils/dateFormatCustom.js';
import { mapState } from 'vuex';

export default {
  name: 'PendudukdetailAdmin',
  data: () => ({
    alertgetdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      updatedata: false,
    },
    filter: {
      search: '',
    },
    prefix: process.env.VUE_APP_PREFIX,
    api: process.env.VUE_APP_API,
    listkelamin: ['L', 'P'],
    listagama: ['Hindu', 'Budha', 'Kristen', 'Katolik', 'Islam', 'Other'],
    listpendidikan: ['SD', 'SLTP', 'SLTA', 'D1', 'D2', 'D3', 'D4', 'S1', 'S2', 'S3', 'Tidak Sekolah'],
    listpekerjaan: [],
    liststatus: ['permohonan', 'proses', 'siap', 'selesai', 'batal'],
    detaildata: null,
    updatdata: [],
    datakk: [],
    headers: [
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
      { text: 'Nama', value: 'nama' },
      { text: 'NIK', value: 'nik' },
      { text: 'Kelamin', value: 'kelamin' },
      { text: 'Tempat Lahir', value: 'tempat_lahir' },
      { text: 'Tgl.Lahir', value: 'tanggal_lahir' },
      { text: 'Agama', value: 'agama' },
      { text: 'Pendidikan', value: 'pendidikan' },
      { text: 'Pekerjaan', value: 'pekerjaan' },
      { text: 'Email', value: 'email' },
      { text: 'Phone', value: 'phone' },
    ],
    formadd: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
      phone: (v) => v && v.length <= 12 || 'Max 12 characters',
    },
    urlprint: '',
    param: {
      nikakun: '',
      typeakun: 'user',
    },
    backbtn: { name: 'PendudukAdmin' },
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
  }),
  created: () => ({
  }),
  watch: {
    '$route.query.nik'(val) {
      if (val) {
        this.param.nikakun = val;
        this.getDetailAkun();
      }
    },
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'usernik',
      'staticdata',
    ]),
  },
  mounted() {
    if (this.$route.query.nik && this.$route.query.nik !== '') {
      this.param.nikakun = this.$route.query.nik;
      // type
      if (this.$route.query.type && this.$route.query.type !== '') {
        this.param.typeakun = this.$route.query.type;
      } else {
        this.param.typeakun = 'user';
      }
      // tombol kembali
      if (this.param.typeakun === 'klian') {
        this.backbtn = { name: 'KlianbanjarAdmin' };
      } else {
        this.backbtn = { name: 'PendudukAdmin' };
      }
      this.getDetailAkun();
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
    dateToIndo(value) {
      return getDateTodayId(value);
    },
    kelaminParse(value) {
      return value === 'L' ? 'Laki-Laki' : 'Perempuan';
    },
  },
  methods: {
    getDetailAkun() {
      if (this.tokenscr && this.param.nikakun !== '' && this.param.typeakun !== '') {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/penduduk/',
            {
              params: {
                role: this.param.typeakun,
                nikakun: this.param.nikakun,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.detaildata = resdata.data[0];
                  // this.updatdata = resdata.data[0];
                  // this.urlprint = this.api + '/public/surat/' + this.kodesurat + '/' + resdata.data[0].nik_surat;
                  this.getDataKk(resdata.data[0].no_kk, this.param.typeakun);
                  this.getPekerjaan();
                } else {
                  this.alertgetdata.show = true;
                  this.alertgetdata.type = 'error';
                  this.alertgetdata.text = 'Data tidak ditemukan!';
                }
              } else {
                this.alertgetdata.show = true;
                this.alertgetdata.type = 'error';
                this.alertgetdata.text = resdata.message;
              }
            } else {
              this.alertgetdata.show = true;
              this.alertgetdata.type = 'error';
              this.alertgetdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertgetdata.show = true;
            this.alertgetdata.type = 'error';
            this.alertgetdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      }
    },
    getDataKk(nomorkk, type) {
      if (this.tokenscr && nomorkk !== '' && type !== '') {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/penduduk/',
            {
              params: {
                role: type,
                nokk: nomorkk,
                orderby: 'kepalakeluarga',
                ordertype: 'DESC',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datakk = resdata.data;
              } else {
                this.alertgetdata.show = true;
                this.alertgetdata.type = 'error';
                this.alertgetdata.text = resdata.message;
              }
            } else {
              this.alertgetdata.show = true;
              this.alertgetdata.type = 'error';
              this.alertgetdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertgetdata.show = true;
            this.alertgetdata.type = 'error';
            this.alertgetdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      }
    },
    getPekerjaan() {
      this.listpekerjaan = [];
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listpekerjaan = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    submitUpdate() {
      this.alertdata.show = false;
      if (this.$refs.formupdatdata.validate()) {
        if (this.tokenscr) {
          this.loading.updatedata = true;
          this.axios
            .put(
              this.api + '/api/penduduk/',
              qs.stringify(
                this.detaildata,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Data akun "' + this.detaildata.nik + '" berhasil diperbaharui!';
                  // this.getDetailSurat();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.updatedata = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.updatedata = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-underline{
    text-decoration: underline;
  }
  .border-solid-thin{
    border: solid thin #f1f1f1;
  }
</style>
